var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('BaseBreadcrumb',{attrs:{"title":_vm.$vuetify.lang.t('$vuetify.VEHICLE_GROUPS.TITLE'),"breadcrumbs":[
      {
        text: _vm.$vuetify.lang.t('$vuetify.VEHICLE_GROUPS.TITLE'),
        disabled: true
      }
    ]}}),_c('v-card',[_c('v-card-text',[_c('v-row',{staticClass:"d-flex align-center justify-end px-4"},[_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){_vm.vehicleGroupEditDialog = true}}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.VEHICLE_GROUPS.ADD_NEW'))+" ")],1)],1),_c('v-data-table',{attrs:{"headers":[
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'ID'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.VEHICLE_GROUPS.GROUP_NAME'),
            align: 'start',
            sortable: false,
            value: 'name'
          },
          {
            text: '',
            align: 'end',
            sortable: false,
            value: 'actions'
          }
        ],"items":_vm.vehicleGroups,"hide-default-footer":"","items-per-page":-1},scopedSlots:_vm._u([{key:"item.actions",fn:function(props){return [_c('td',{staticClass:"d-flex align-center justify-end"},[(_vm.isGlobalAdmin)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){return _vm.openVehicleGroupEditDialog(props.item)}}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pencil")])],1)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.EDIT'))+" ")])]):_vm._e()],1)]}}])})],1)],1),_c('VehicleGroupEditDialog',{attrs:{"visible":_vm.vehicleGroupEditDialog},on:{"close":function($event){_vm.vehicleGroupEditDialog = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }